import React from "react"
import { Accordion } from "../Accordion/Accordion"
import styled from "@emotion/styled"
import tw from "twin.macro"

import CartUpsellProducts from "./CartUpsellProducts"

const UpsellBox = styled.div`
  ${tw`w-full`}
  background: white;
`

const CartUpsells: React.FC = () => {
  return (
    <>
      <UpsellBox>
        <Accordion key={`upsell_content`} size={`upsell`} title="More More More!">
          <CartUpsellProducts />
        </Accordion>
      </UpsellBox>
    </>
  )
}

export default React.memo(CartUpsells)
